module.exports = new __parcel__URL__("logo.bd44c765.png").toString();